module.exports = __webpack_public_path__ + "img/fo.f468dcb7.svg";